import {constants, mediaQueryStyles, typographyStyles as Typography} from '@newsela/angelou';
import {css} from 'emotion';

const {BreakpointNames, mediaQuery} = mediaQueryStyles;
const angelouUI = constants.colors.ui;
const coreBlue700 = angelouUI.coreBlue[700];
const grey500 = angelouUI.grey[500];
const errorColor = angelouUI.red[500];


const errorMessage = css`
  background: ${errorColor};
  padding: 10px;
  border-radius: 4px;
  color: white;
`;

const forgotPassword = {fontWeight: 'bold'};

const formContainer = css`
  max-width: 343px;
  padding-bottom: 66px;
  margin: 0 auto;
  ${mediaQuery.downTo(BreakpointNames.sm)} {
      max-width: 462px;
  };
`;

const joinNow = Typography.heading6.styles;

const links = css`
  text-align: center;
  color: ${grey500};
`;

const socialLink = css`
  width: 141px;
  height: 48px;
  margin-right: 10px;
  ${mediaQuery.upTo(BreakpointNames.sm)} {
    width: 100%;
    margin-bottom: 16px !important;
  };

  display: flex;
  justify-content: left !important;
  align-items: center;
`;

const googleIcon = css`
    margin-right: 110px;
  ${mediaQuery.downTo(BreakpointNames.sm)} {
    margin-right: 21px;
  };
`;

const microsoftIcon = css`
    margin-right: 110px;
  ${mediaQuery.downTo(BreakpointNames.sm)} {
    margin-right: 16px;
  };
`;

const cleverIcon = css`
    margin-right: 110px;
  ${mediaQuery.downTo(BreakpointNames.sm)} {
    margin-right: 25px;
  };
`;

const textInputFocus = `
  &:focus {
    border: 2px solid ${coreBlue700};
  }
`;

const thirdPartyAnchors = css`
  display: flex;
  justify-content: center;
  ${mediaQuery.upTo(BreakpointNames.sm)} {
    flex-direction: column;
    align-items: center;
  };
`;

export default {
  cleverIcon,
  errorMessage,
  forgotPassword,
  formContainer,
  googleIcon,
  joinNow,
  links,
  microsoftIcon,
  socialLink,
  textInputFocus,
  thirdPartyAnchors,
};
